// SolarBrandsTable.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { fetchData } from "../helper/api.interceptor";
import EditSolarPanelModal from "./EditSolarPanelModal";
import DeleteSolarPanelButton from "./DeleteInverterButton"; // updated name

const SolarBrandsTable = () => {
    const [panels, setPanels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);

    const fetchPanels = async () => {
        setLoading(true);
        try {
            const response = await fetchData.get("/solar/solar-panels-admin");
            if (Array.isArray(response?.result)) {
                setPanels(response.result);
            } else {
                setError("No solar panels found");
            }
        } catch (err) {
            console.error("Error:", err);
            setError("Failed to load solar panel data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPanels();
    }, []);

    const handleItemsPerPageChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setItemsPerPage(value);
    };

    const handleAddClick = () => {
        setEditData(null);
        setShowModal(true);
    };

    const handleEditClick = (panel) => {
        setEditData(panel);
        setShowModal(true);
    };

    if (loading) return <div className="text-center p-4">Loading solar panels...</div>;
    if (error) return <div className="text-danger text-center p-4">{error}</div>;

    return (


        <div className="mt-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">   <Icon icon="mdi:solar-panel" className="menu-icon" /> | Panel Brands</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">All Solar Panel Brands</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto no-bg-position"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={panels.length}>All</option>
                        </select>
                    </div>
                    <button className="btn btn-warning rounded-pill fw-medium d-flex align-items-center gap-2" onClick={handleAddClick}>
                        <Icon icon="mdi:plus" className="fs-5" />
                        Add Solar Panel
                    </button>
                </div>

                <div className="card-body table-responsive">
                    <table className="table bordered-table table-hover align-middle">
                        <thead>
                            <tr style={{ fontSize: "15px" }}>
                                <th className="text-center">#</th>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Capacity</th>
                                <th>Category</th>
                                <th>Type</th>
                                <th>Price</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {panels.map((panel, index) => (
                                <tr key={panel.id} style={{ fontSize: "15px" }}>
                                    <td className="text-center">{index + 1}</td>
                                    <td>
                                        <img
                                            src={panel.image || "/placeholder.png"}
                                            style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                            alt={panel.name}
                                        />
                                    </td>
                                    <td className="align-middle">{panel.name}</td>
                                    <td className="align-middle">{panel.capacity}</td>
                                    <td className="align-middle">{panel.category}</td>
                                    <td className="align-middle">{panel.type}</td>
                                    <td className="align-middle">{panel.price}</td>
                                    <td className="text-center">
                                        <div className="d-flex justify-content-center gap-2">
                                            <button
                                                className="w-32-px h-32-px bg-warning-subtle text-warning rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                                                onClick={() => handleEditClick(panel)}
                                            >
                                                <Icon icon="mdi:pencil-outline" className="fs-5" />
                                            </button>
                                            <DeleteSolarPanelButton id={panel.id} onDeleted={fetchPanels} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <EditSolarPanelModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    editData={editData}
                    refreshList={fetchPanels}
                />
            )}
        </div>
    );
};

export default SolarBrandsTable;
